import { render, staticRenderFns } from "./rename.vue?vue&type=template&id=38f9d40e&scoped=true&"
import script from "./rename.vue?vue&type=script&lang=ts&"
export * from "./rename.vue?vue&type=script&lang=ts&"
import style0 from "./rename.vue?vue&type=style&index=0&id=38f9d40e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f9d40e",
  null
  
)

export default component.exports